<template lang="pug">
    div.hidden
        el-form-item(prop="name")
        el-form-item(prop="config.template")
        div(v-if="domains && domains.length" v-for="(domain, d) in domains")
            el-form-item(:prop="'domains.' + d + '.base_url'")
        //- Billing address validation fields
        div(v-if="billingAddress")
            el-form-item(prop="billingAddress.street")
            el-form-item(prop="billingAddress.zipcode")
            el-form-item(prop="billingAddress.city")
            el-form-item(prop="billingAddress.country")
        //- Single-card business card fields. Always-mounted shadow form-items
        //- so $refs.form.validate() sees them regardless of which tab the
        //- admin is currently on (router-view tears down inactive tabs).
        div(v-if="hasSingleCard")
            el-form-item(prop="businessCard.description")
            el-form-item(prop="businessCard.category")
            el-form-item(prop="businessCard.homepage_url")
            el-form-item(prop="businessCard.email")
            div(v-if="hasSingleCardAddressOverride")
                el-form-item(prop="businessCard.address.street")
                el-form-item(prop="businessCard.address.zipcode")
                el-form-item(prop="businessCard.address.city")
                el-form-item(prop="businessCard.address.country")
        //- Chain-of-stores: one shadow per branch card, with address sub-rules
        //- only when an override is set on that card.
        div(v-for="(card, i) in businessCards" :key="`bc-shadow-${i}`")
            el-form-item(:prop="`businessCards.${i}.description`")
            el-form-item(:prop="`businessCards.${i}.category`")
            el-form-item(:prop="`businessCards.${i}.homepage_url`")
            el-form-item(:prop="`businessCards.${i}.email`")
            div(v-if="hasOverrideAddress(card)")
                el-form-item(:prop="`businessCards.${i}.address.street`")
                el-form-item(:prop="`businessCards.${i}.address.zipcode`")
                el-form-item(:prop="`businessCards.${i}.address.city`")
                el-form-item(:prop="`businessCards.${i}.address.country`")
</template>

<script>

import _ from 'lodash'
import { useSettingsStore } from '@/stores'

export default {
    name: 'AllInputFields',
    computed: {
        domains() {
            return _.get(this.form, 'domains') || []
        },
        form() {
            return useSettingsStore().form;
        },
        billingAddress() {
            return _.get(this.form, 'billingAddress')
        },
        // Business card is only validated when the billing feature is enabled
        // (mirrors the `rules` getter gate in stores/settings.js). Otherwise
        // these always-mounted shadow form-items would force-validate
        // businessCard.category on every save and block unrelated tabs.
        isBusinessCardEnabled() {
            return !!_.get(this.form, 'is_business_card')
        },
        hasSingleCard() {
            return this.isBusinessCardEnabled && !!_.get(this.form, 'businessCard')
        },
        hasSingleCardAddressOverride() {
            const address = _.get(this.form, 'businessCard.address')
            return !!(address && !address.deleted)
        },
        businessCards() {
            if (!this.isBusinessCardEnabled) return []
            return _.get(this.form, 'businessCards') || []
        },
    },
    methods: {
        hasOverrideAddress(card) {
            const address = _.get(card, 'address')
            return !!(address && !address.deleted)
        },
    },
}
</script>
